import { render, staticRenderFns } from "./UndecidedDetail.vue?vue&type=template&id=4f1a25f1&scoped=true&"
import script from "./UndecidedDetail.vue?vue&type=script&lang=js&"
export * from "./UndecidedDetail.vue?vue&type=script&lang=js&"
import style0 from "./UndecidedDetail.vue?vue&type=style&index=0&id=4f1a25f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1a25f1",
  null
  
)

export default component.exports